import http from '@axios'
import {getUserToken, getUserData} from "@/helpers/Utils";

const endpoint = `/bsims`;

const body = {
  "req": {
    "id": 123342523,
    "time": "2021-08-09T10:11:20+07:00",
    "src": "member-web",
    "op": "findContainerLocal"
  },
  "data": {}
};

const findContainerLocal = (data) => {
  
  const user = getUserData();
  body.req.op = "findContainerLocal";
  body.req.uid = user.id; //test off
  body.req.uname = user.username; //test off
  body.req.token = getUserToken();
  body.data = data;
  console.log(body);
  return http.post(endpoint, body);
}

const listBSIMSdoc = data => {
  const user = getUserData();
  body.req.op = "listBSIMSdoc";
  body.req.uid = user.id;
  body.req.uname = user.username;
  body.req.token = getUserToken();
  body.data = data;
  return http.post(endpoint, body);
}

const delBSIMSdoc = id => {
  const user = getUserData();
  body.req.op = "delBSIMSdoc";
  body.req.uid = user.id;
  body.req.uname = user.username;
  body.req.token = getUserToken();
  body.data = {
    doc_id: id
  };
  return http.post(endpoint, body);
}

export { findContainerLocal, listBSIMSdoc, delBSIMSdoc, }
